var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChooseApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31723_78849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0312 7.0625H5.96875C5.36469 7.0625 4.875 7.55219 4.875 8.15625V27.8438C4.875 28.4478 5.36469 28.9375 5.96875 28.9375H30.0312C30.6353 28.9375 31.125 28.4478 31.125 27.8438V8.15625C31.125 7.55219 30.6353 7.0625 30.0312 7.0625Z",
    stroke: "#42296E",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79688 10.4121C10.6652 10.4121 11.3691 11.116 11.3691 11.9844C11.3691 12.8527 10.6652 13.5566 9.79688 13.5566C8.92854 13.5566 8.22461 12.8527 8.22461 11.9844C8.22461 11.116 8.92854 10.4121 9.79688 10.4121Z",
    fill: "#42296E",
    stroke: "#42296E",
    strokeWidth: 0.136719
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2656 13.625C16.1717 13.625 16.9062 12.8905 16.9062 11.9844C16.9062 11.0783 16.1717 10.3438 15.2656 10.3438C14.3595 10.3438 13.625 11.0783 13.625 11.9844C13.625 12.8905 14.3595 13.625 15.2656 13.625Z",
    fill: "#42296E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31723_78849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseApp);
export default __webpack_public_path__ + "static/media/choose_app.d8bf2c875275cee6de4d65f91a89818f.svg";
export { ForwardRef as ReactComponent };